import { render, staticRenderFns } from "./index.html?vue&type=template&id=3cb7b4a3&external"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./index.vue?vue&type=style&index=0&id=3cb7b4a3&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb7b4a3')) {
      api.createRecord('3cb7b4a3', component.options)
    } else {
      api.reload('3cb7b4a3', component.options)
    }
    module.hot.accept("./index.html?vue&type=template&id=3cb7b4a3&external", function () {
      api.rerender('3cb7b4a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-editable-title/index.vue"
export default component.exports